import { useState, useEffect } from 'react';
import './Hero.css';

const METRICS = [
  { label: 'Tests',        val: '883',  color: '#ef4444', trend: '-98.2%' },
  { label: 'Invited',      val: '168',  color: '#8b5cf6', trend: '-96.6%' },
  { label: 'Attempted',    val: '59',   color: '#f59e0b', trend: '-96.2%' },
  { label: 'Pass Rate',    val: '49%',  color: '#22c55e', trend: '49.2%' },
  { label: 'Active Jobs',  val: '36',   color: '#3b82f6', trend: '0 pending' },
  { label: 'Avg Score',    val: '24%',  color: '#a78bfa', trend: '8.0 avg' },
];

export default function Hero() {
  const [activeMetric, setActiveMetric] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActiveMetric(p => (p + 1) % METRICS.length), 2000);
    return () => clearInterval(t);
  }, []);

  const scrollTo = (id) => {
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="hero__bg-glow" />
      <div className="hero__particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="hero__particle" style={{
            left: `${Math.random()*100}%`,
            top: `${Math.random()*100}%`,
            animationDelay: `${Math.random()*5}s`,
            animationDuration: `${3+Math.random()*4}s`,
            width: `${2+Math.random()*3}px`,
            height: `${2+Math.random()*3}px`,
          }} />
        ))}
      </div>

      <div className="hero__left">
        <div className="badge rise delay-1">
          <span className="pulse-dot" />
          AI-Powered Hiring Platform · Aiprus Software
        </div>

        <div className="hero__acronym rise delay-2">
          {[
            ['V','alidated'],
            ['E','valuation &'],
            ['R','ecruitment'],
            ['D','ecisions with'],
            ['I','ntelligent'],
            ['C','ompetency'],
            ['T','racking'],
          ].map(([letter, rest]) => (
            <div key={letter} className="hero__acronym-line">
              <span className="hero__acronym-letter">{letter}</span>
              <span className="hero__acronym-rest">{rest}</span>
            </div>
          ))}
        </div>

        <p className="hero__sub rise delay-4">
          One platform. Two portals. The complete AI-powered hiring ecosystem —
          for recruiters who demand precision and candidates who deserve transparency.
        </p>

        <div className="hero__actions rise delay-5">
          <button className="btn-purple" onClick={() => scrollTo('#admin')}>Explore Admin Portal</button>
          <button className="btn-outline" onClick={() => scrollTo('#candidate')}>Candidate Portal →</button>
        </div>

        <div className="hero__trust rise delay-6">
          {['Validated AI scoring','Full audit trail','Role-based access','Candidate portal included'].map(t => (
            <div key={t} className="trust-item"><span className="trust-check">✓</span>{t}</div>
          ))}
        </div>
      </div>

      {/* Animated dashboard mockup */}
      <div className="hero__right rise delay-3">
        <div className="dash-mockup">
          <div className="dm-header">
            <div className="dm-dots"><span className="dm-dot dm-dot--r"/><span className="dm-dot dm-dot--y"/><span className="dm-dot dm-dot--g"/></div>
            <div className="dm-title">VERDICT Admin · Dashboard</div>
            <div className="dm-user">
              <div className="dm-av">SO</div>
              <span>sobhit</span>
            </div>
          </div>
          <div className="dm-body">
            <div className="dm-sidebar">
              {['Dashboard','Post a Job','Applications','Workflows','Test Builder','Questions','Manage Tests','Test Results','Candidate Hub','Resume Library'].map((item, i) => (
                <div key={item} className={`dm-nav ${i === 0 ? 'dm-nav--active' : ''}`}>{item}</div>
              ))}
            </div>
            <div className="dm-main">
              <div className="dm-tabs">
                <span className="dm-tab dm-tab--active">Overview</span>
                <span className="dm-tab">Recruiter Analytics</span>
                <span className="dm-tab">Job Analytics</span>
              </div>
              <div className="dm-snapshot">
                <span className="dm-snapshot-text">2026-06-25 – 2026-07-02 snapshot: 883 tests created, 168 candidates invited, 59 attempted, 49% pass rate</span>
              </div>
              <div className="dm-metrics">
                {METRICS.map((m, i) => (
                  <div key={m.label} className={`dm-metric ${activeMetric === i ? 'dm-metric--active' : ''}`} style={{'--mc': m.color}}>
                    <div className="dm-metric__val">{m.val}</div>
                    <div className="dm-metric__label">{m.label}</div>
                    <div className="dm-metric__trend" style={{color: m.color}}>{m.trend}</div>
                  </div>
                ))}
              </div>
              <div className="dm-actions-row">
                {[
                  {icon:'✏️', label:'Setup a New Test', color:'#8b5cf6'},
                  {icon:'💼', label:'Post a New Job',   color:'#22c55e'},
                  {icon:'👥', label:'View Applications', color:'#3b82f6'},
                  {icon:'📊', label:'Hiring Reports',   color:'#f59e0b'},
                ].map(a => (
                  <div key={a.label} className="dm-action-card" style={{'--ac': a.color}}>
                    <span className="dm-action-icon">{a.icon}</span>
                    <span className="dm-action-label">{a.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Floating badges */}
        <div className="hero__float hero__float--1">
          <div className="float-dot" />
          <div>
            <div className="float-val">49%</div>
            <div className="float-label">Pass Rate</div>
          </div>
        </div>
        <div className="hero__float hero__float--2">
          <span className="float-icon">🎯</span>
          <div>
            <div className="float-val">36</div>
            <div className="float-label">Active Jobs</div>
          </div>
        </div>
        <div className="hero__float hero__float--3">
          <span className="float-icon">📋</span>
          <div>
            <div className="float-val">883</div>
            <div className="float-label">Tests Created</div>
          </div>
        </div>
      </div>
    </section>
  );
}
